import jwt_decode from "jwt-decode";

type DecodedTokenType = {
  exp: number;
  iat: number;
};

export function validateToken(token: string) {
  const decodedToken = jwt_decode(token) as DecodedTokenType | null;
  if (!decodedToken) return false;

  return decodedToken.exp > Date.now() / 1000;
}
